import { useTranslation } from 'react-i18next'
import { ReactSVG } from 'react-svg'

import { useFetchMyBonusTotal } from '@entities/Loyalty'

import { formatPrice } from '@shared/uttils'

import styles from './styles.module.scss'

/**
 * Форматирует timestamp в человекочитаемую дату
 */
function formatHumanDate (date: Date): string {
  return date.toLocaleDateString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
  })
}

export function TokenAccountsList () {
  const { t: tn } = useTranslation('personal')
  const { bonus } = useFetchMyBonusTotal()

  const tokenAccountsWithBalance = bonus?.tokenAccounts?.filter(
    (account) => account.totalBalance > 0
  ) ?? []

  if (tokenAccountsWithBalance.length === 0) {
    return null
  }

  return (
    <div className={styles.tokenAccounts}>
      <h3 className={styles.tokenAccounts__title}>{tn('tokenAccounts.title')}</h3>
      <div className={styles.tokenAccounts__list}>
        {tokenAccountsWithBalance.map((account, index) => (
          <div 
            key={account.id} 
            className={styles.tokenAccounts__item}
            style={{
              borderBottom: index < tokenAccountsWithBalance.length - 1 
                ? '1px solid var(--dark-400)' 
                : 'none'
            }}
          >
            <div className={styles.tokenAccounts__info}>
              <span className={styles.tokenAccounts__name}>{account.name}</span>
              {account.expireAmount && account.expireAmount !== 0 ? (
                <span className={styles.tokenAccounts__expire}>
                  <ReactSVG src="/icons/flame.svg" wrapper="span" />
                  {Math.abs(account.expireAmount)} {account.nameCases?.plural || tn('bonus.bonuses')} {tn('bonusHistory.expire')} {formatHumanDate(new Date(account.expirationAt))}
                </span>
              ) : null}
            </div>
            <span className={styles.tokenAccounts__balance}>
              {formatPrice(account.totalBalance, {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
                style: 'decimal',
              })} {account.nameCases?.abbreviation || ''}
            </span>
          </div>
        ))}
      </div>
    </div>
  )
}
